module.exports = __webpack_public_path__ + "img/NYI - Bingo.4dba819b.jpeg";